import { Button, type ButtonProps } from '@mantine/core';
import { VACANCY_STATUS_MODEL } from '../constants';
import commonStyles from '../vacancyStatus.module.scss';
import { IconChevronsDown } from '@tabler/icons-react';

type VacancyStatusButtonProps = {
  status?: string;
  onClick?: () => void;
} & ButtonProps;

export const VacancyStatusButton = ({
  status,
  ...props
}: VacancyStatusButtonProps) => {
  if (!status) {
    return null;
  }

  switch (status) {
    case VACANCY_STATUS_MODEL.NEW:
      return (
        <Button
          className={`${commonStyles.vacancyStatusButton} ${commonStyles.vacancyStatusNew}`}
          rightSection={
            <IconChevronsDown color='var(--mantine-color-otherWhite-0)' />
          }
          size='md'
          {...props}
        >
          Новая
        </Button>
      );
    case VACANCY_STATUS_MODEL.IN_PROGRESS:
      return (
        <Button
          className={`${commonStyles.vacancyStatusButton} ${commonStyles.vacancyStatusInProgress}`}
          rightSection={
            <IconChevronsDown color='var(--mantine-color-secondary-9)' />
          }
          size='md'
          {...props}
        >
          Идёт подбор
        </Button>
      );
    case VACANCY_STATUS_MODEL.SELECTION_SUSPENDED:
      return (
        <Button
          className={`${commonStyles.vacancyStatusButton} ${commonStyles.vacancyStatusSuspended}`}
          rightSection={
            <IconChevronsDown color='var(--mantine-color-tertiary-9)' />
          }
          size='md'
          {...props}
        >
          Подбор приостановлен
        </Button>
      );
    case VACANCY_STATUS_MODEL.SELECTION_COMPLETED:
      return (
        <Button
          className={`${commonStyles.vacancyStatusButton} ${commonStyles.vacancyStatusCompleted}`}
          rightSection={
            <IconChevronsDown color='var(--mantine-color-green-9)' />
          }
          size='md'
          {...props}
        >
          Подбор выполнен
        </Button>
      );
    case VACANCY_STATUS_MODEL.SELECTION_CANCELLED:
      return (
        <Button
          className={`${commonStyles.vacancyStatusButton} ${commonStyles.vacancyStatusCancelled}`}
          rightSection={<IconChevronsDown color='var(--mantine-color-red-7)' />}
          size='md'
          {...props}
        >
          Подбор отменен
        </Button>
      );
    case VACANCY_STATUS_MODEL.ARCHIVED:
      return (
        <Button
          className={`${commonStyles.vacancyStatusButton} ${commonStyles.vacancyStatusArchived}`}
          size='md'
          {...props}
        >
          В архиве
        </Button>
      );
    default:
      return null;
  }
};
